unit UnclaimedValidationForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, BaseList, Data.DB, WEBLib.ExtCtrls, WEBLib.Actions,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Grids, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.Lists, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.WebCtrls,
  smx.webcore.types, XData.Web.Client, Generics.Collections, GiftAidValidationErrorMessages;

type
  TUnclaimedValidationList = class(TBaseListForm)
    CaptionSpan: THTMLSpan;
    EditDonorDataset: TXDataWebDataSet;
    MainDatasetId: TIntegerField;
    MainDatasetDonorId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetExternalId: TStringField;
    MainDatasetSponsored: TBooleanField;
    MainDatasetNonGiftaidableByCustomerRequest: TBooleanField;
    MainDatasetTransactionDate: TDateTimeField;
    MainDatasetImportId: TIntegerField;
    MainDatasetClaimId: TIntegerField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetClaimDate: TDateTimeField;
    MainDatasetTaxYear: TIntegerField;
    MainDatasetDonorPostCode: TStringField;
    MainDatasetDonorName: TStringField;
    MainDatasetErrorText: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetSourceType: TStringField;
    MainDatasetComment: TStringField;
    MainDatasetDonationKind: TStringField;
    MainDatasetOtherDonationKind: TStringField;
    MainDatasetPaymentMethod: TStringField;
    MainDatasetPaymentMethodNote: TStringField;
    MainDatasetBankingDate: TDateField;
    MainDatasetBankingReference: TStringField;
    MainDatasetBankingReference2: TStringField;
    MainDatasetAnalysisCode1: TStringField;
    MainDatasetAnalysisCode2: TStringField;
    MainDatasetAnalysisCode3: TStringField;
    MainDatasetAdjustmentID: TIntegerField;
    EditDonorDatasetId: TIntegerField;
    EditDonorDatasetDateAdded: TDateTimeField;
    EditDonorDatasetAddedBy: TIntegerField;
    EditDonorDatasetLastUpdatedBy: TIntegerField;
    EditDonorDatasetLastUpdated: TDateTimeField;
    EditDonorDatasetTitle: TStringField;
    EditDonorDatasetFirstName: TStringField;
    EditDonorDatasetMiddleName: TStringField;
    EditDonorDatasetLastName: TStringField;
    EditDonorDatasetSuffix: TStringField;
    EditDonorDatasetAdd1: TStringField;
    EditDonorDatasetAdd2: TStringField;
    EditDonorDatasetAdd3: TStringField;
    EditDonorDatasetCity: TStringField;
    EditDonorDatasetPostCode: TStringField;
    EditDonorDatasetEmail: TStringField;
    EditDonorDatasetMobile: TStringField;
    EditDonorDatasetTelephone: TStringField;
    EditDonorDatasetMatchHash: TStringField;
    EditDonorDatasetContactByPhone: TBooleanField;
    EditDonorDatasetContactByPost: TBooleanField;
    EditDonorDatasetContactByText: TBooleanField;
    EditDonorDatasetContactByEmail: TBooleanField;
    EditDonorDatasetDOB: TDateField;
    EditDonorDatasetHearingStatus: TStringField;
    EditDonorDatasetEmailStatus: TStringField;
    EditDonorDatasetLatitude: TFloatField;
    EditDonorDatasetLongitude: TFloatField;
    EditDonorDatasetExternalId: TStringField;
    EditDonorDatasetCountryCode: TStringField;
    EditDonorDatasetVisualStatus: TStringField;
    EditDonorDatasetMobilityStatus: TStringField;
    EditDonorDatasetSourceType: TStringField;
    EditDonorDatasetClaimStatus: TStringField;
    EditDonorDatasetCharityTenant: TStringField;
    EditDonorDatasetComments: TStringField;
    EditDonorDatasetImportId: TIntegerField;
    EditDonorDatasetCounty: TStringField;
    EditDonorDatasetLocationType: TStringField;
    EditDonorDatasetOrganisationName: TStringField;
    EditDonorDatasetDonorKind: TStringField;
    EditDonorDatasetDateOfDeath: TDateTimeField;
    MainDatasetValidationText: TStringField;
    AutoFixButton: TButton;
    RefreshButton: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure SearchButtonClick(Sender: TObject);
    procedure MainDatasetValidationTextGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure AutoFixButtonClick(Sender: TObject);
    procedure RefreshButtonClick(Sender: TObject);
  private
    FShowStatus: String;
    FValidationFailureFilter: String;
    FDonationIdToErrorText: TDictionary<Integer, string>;
    procedure SetShowCaption(const Value: String);
    [async]
    function LoadDonorForId(ADonorId: Integer): Boolean; async;
    [async]
    procedure OpenDonationEdit(const ADonationId: string); async;
    [async]
    procedure OpenDonorEdit(const ADonorId: Integer); async;
    [async]
    procedure TryAutoFix; async;
    procedure UpdateRefreshButtonCaption;
    function BuildSearchFilter(const Value: string): string;
    function CombineWithValidationFilter(const ASearchFilter: string): string;
    { Private declarations }
  protected
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure UnLockControls(const AUnLock: Boolean); override;
    procedure PrepareForm; override;
    procedure LoadData; override;
    [async]
    procedure LoadDataAsync; async;

    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;
    function CreateGridInFormCreate: boolean; override;
    procedure SearchData(const Value: string); override;
  public
    { Public declarations }
    property ShowStatus: String read FShowStatus write FShowStatus;
    property ShowCaption: String write SetShowCaption;
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  MainDataModule,
  SMX.Web.Layout.Utils,
  DonationDataEdit,
  DonorForm,
  WebForm.Core,
  XData.Dataset.Utils,
  UnclaimedValidationAutoFixForm,
  GA.Web.Utils,
  SMX.CRM.Utils,
  SMX.Web.Utils;

procedure TUnclaimedValidationList.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
var
  LDonorId: Integer;
  LDonationId: string;
  Span: THTMLSpan;

  procedure EditDonationClick(Sender: TObject);
  begin
    OpenDonationEdit(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure EditDonorClick(Sender: TObject);
  var
    LEditDonorId: Integer;
  begin
    LEditDonorId := StrToIntDef(TJSHTMLElement(THTMLSpan(Sender).ElementHandle).getAttribute('data-donor-id'), 0);
    if LEditDonorId > 0 then
      OpenDonorEdit(LEditDonorId);
  end;
begin
  LDonationId := ARecordId;
  LDonorId := MainDataset.FieldByName('DonorId').AsInteger;

  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'Edit Donation');
  TLayoutUtils.SetActionRecordId(Span, LDonationId);
  Span.OnClick := @EditDonationClick;

  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-user-edit', 'Edit Donor');
  TLayoutUtils.SetActionRecordId(Span, LDonationId);
  TJSHTMLElement(Span.ElementHandle).setAttribute('data-donor-id', LDonorId.ToString);
  Span.OnClick := @EditDonorClick;
end;

procedure TUnclaimedValidationList.UnLockControls(const AUnLock: Boolean);
begin
  inherited UnLockControls(AUnLock);
  DataTable.Enabled := AUnLock;
  AutoFixButton.Enabled := AUnLock;
  RefreshButton.Enabled := AUnLock;
end;

procedure TUnclaimedValidationList.UpdateRefreshButtonCaption;
begin
  RefreshButton.Caption := Format('Refresh (%s)', [FormatDateTime('hh:nn', Now)]);
end;

procedure TUnclaimedValidationList.RefreshButtonClick(Sender: TObject);
begin
  LoadDataAsync;
end;

procedure TUnclaimedValidationList.AutoFixButtonClick(Sender: TObject);
begin
  TryAutoFix;
end;

procedure TUnclaimedValidationList.LoadData;
begin
//  inherited;
  LoadDataAsync;
end;

procedure TUnclaimedValidationList.LoadDataAsync;
var
  lRetval: TXDataClientResponse;
  lItems: JS.TJSArray;
  lFilter: String;
  I: Integer;
  lDonationId: Integer;
begin
  MessageLabel.Caption := 'Refreshing Data...';
  UnLockControls(False);
  try
    if FGridPlugin = nil then
      CreateGridPlugin;
    FDonationIdToErrorText.Clear;
    lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetUnclaimedDonationIdsFailingValidation', []));
    lItems := nil;

    if (lRetval.ResultAsObject <> nil) and (lRetval.ResultAsObject['value'] <> nil) then
      lItems := JS.ToArray(lRetval.ResultAsObject['value'])
    else if lRetval.ResultAsObject <> nil then
      lItems := JS.ToArray(lRetval.ResultAsObject);

    if (lItems = nil) or (lItems.Length = 0) then
      lFilter := 'Id eq -1'
    else
    begin
      lFilter := '';
      for I := 0 to lItems.Length - 1 do
      begin
        lDonationId := JS.toInteger(TJSObject(lItems[I])['DonationId']);
        FDonationIdToErrorText.Add(lDonationId, TGiftAidValidationErrorMessages.CsvToShortMessage(string(TJSObject(lItems[I])['ErrorText'])));
        if I = 0 then
          lFilter := 'Id eq ' + IntToStr(lDonationId)
        else
          lFilter := lFilter + ' or Id eq ' + IntToStr(lDonationId);
      end;
    end;

    FValidationFailureFilter := lFilter;
    SearchData(edSearch.Text);
  finally
    UnLockControls(True);
    MessageLabel.Caption := '';
    UpdateRefreshButtonCaption;
  end;
end;

procedure TUnclaimedValidationList.MainDatasetValidationTextGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
var
  lDonationId: Integer;
begin
  lDonationId := Sender.DataSet.FieldByName('Id').AsInteger;
  if not FDonationIdToErrorText.TryGetValue(lDonationId, {o}Text) then
    Text := 'Unknown Error';
end;

procedure TUnclaimedValidationList.PrepareForm;
begin
  FIdField := 'Id';
  FValidationFailureFilter := 'Id eq -1';
end;

procedure TUnclaimedValidationList.SearchButtonClick(Sender: TObject);
begin
  SearchData(edSearch.Text);
end;

procedure TUnclaimedValidationList.SetShowCaption(const Value: String);
begin
  CaptionSpan.HTML.Text := Value;
end;

procedure TUnclaimedValidationList.TryAutoFix;
var
  lRetval: TXDataClientResponse;
  lCount: Integer;
  lOptionsForm: TUnclaimedValidationAutoFixForm;
  lFixTooOld, lFixNoDeclaration, lFixZeroAmount, lFixPostcodes, lFixDonorNames, lFixDonationKinds, lFixDonorKinds: Boolean;
begin
  lOptionsForm := TUnclaimedValidationAutoFixForm.Create(Self);
  try
    lOptionsForm.Popup := True;
    lOptionsForm.PopupOpacity := 1;
    lOptionsForm.ElementClassName := 'PopUpForm';
    await(TForm, lOptionsForm.Load());
    if await(TModalResult, lOptionsForm.Execute) <> mrOk then
      Exit;

    lFixTooOld := lOptionsForm.FixTooOld;
    lFixNoDeclaration := lOptionsForm.FixNoDeclaration;
    lFixZeroAmount := lOptionsForm.FixZeroAmount;
    lFixPostcodes := lOptionsForm.FixPostcodes;
    lFixDonorNames := lOptionsForm.FixDonorNames;
    lFixDonationKinds := lOptionsForm.FixDonationKinds;
    lFixDonorKinds := lOptionsForm.FixDonorKinds;
  finally
    lOptionsForm.Free;
    lOptionsForm := nil;
  end;

  MessageLabel.Caption := 'Applying autofix...';
  UnLockControls(False);
  try
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.AutoFixUnclaimedValidationData', [
        lFixTooOld,
        lFixNoDeclaration,
        lFixZeroAmount,
        lFixPostcodes,
        lFixDonorNames,
        lFixDonationKinds,
        lFixDonorKinds
      ]));
    lCount := JS.toInteger(lRetval.ResultAsObject['value']);
    await(LoadDataAsync);
    MessageLabel.Caption := Format('%d donation(s) updated.', [lCount])
  finally
    UnLockControls(True);
  end;

end;

procedure TUnclaimedValidationList.WebFormCreate(Sender: TObject);
begin
  inherited;
  FDonationIdToErrorText := TDictionary<Integer, string>.Create;
end;

procedure TUnclaimedValidationList.WebFormDestroy(Sender: TObject);
begin
  FDonationIdToErrorText.Free;
  inherited;
end;

procedure TUnclaimedValidationList.WebFormShow(Sender: TObject);
begin
  inherited;
  AddButton.Visible := False;
  LoadData;
end;

function TUnclaimedValidationList.BuildSearchFilter(const Value: string): string;
var
  lPostCode: TPostCodePart;
  lValue, lEscaped: string;
begin
  lValue := Value.Trim;
  if lValue = '' then
    Exit('');

  lPostCode := TCRMUtils.IsPostCode(lValue);
  if lPostCode = pcFull then
    Result := Format('(DonorPostCode eq ''%s'')', [TUtils.EscapeODataLiteral(Uppercase(lValue))])
  else if lPostCode = pcPartial then
    Result := Format('(startswith(DonorPostCode, ''%s''))', [TUtils.EscapeODataLiteral(Uppercase(lValue))])
  else if TUtils.IsNumber(lValue) then
    Result := Format('((Id eq %s) or (DonorId eq %s))', [lValue, lValue])
  else
  begin
    lEscaped := TUtils.EscapeODataLiteral(Uppercase(lValue));
    Result := Format(
      '(contains(upper(DonorName), ''%s'')) or (contains(upper(ErrorText), ''%s''))',
      [lEscaped, lEscaped]);
  end;
end;

function TUnclaimedValidationList.CombineWithValidationFilter(const ASearchFilter: string): string;
begin
  if ASearchFilter <> '' then
    Result := Format('(%s) and (%s)', [FValidationFailureFilter, ASearchFilter])
  else
    Result := FValidationFailureFilter;
end;

procedure TUnclaimedValidationList.SearchData(const Value: string);
begin
  FGridPlugin.SetPreparedFilter(CombineWithValidationFilter(BuildSearchFilter(Value)));
end;

function TUnclaimedValidationList.InitSortCol: Integer;
begin
  Result := 1;
end;

function TUnclaimedValidationList.InitSortDirection: TSortDirection;
begin
  Result := TSortDirection.sdDesc;
end;

function TUnclaimedValidationList.CreateGridInFormCreate: boolean;
begin
  Result := False;
end;

function TUnclaimedValidationList.LoadDonorForId(ADonorId: Integer): Boolean;
begin
  if EditDonorDataset.Active then
    EditDonorDataset.Close;
  EditDonorDataset.QueryString := '$filter=Id eq ' + IntToStr(ADonorId);
  Await(EditDonorDataset.LoadAsync);
  Result := EditDonorDataset.Locate('Id', ADonorId, []);
end;

procedure TUnclaimedValidationList.OpenDonationEdit(const ADonationId: string);
var
  AForm: TDonationDataEditForm;
  LDonorId: Integer;
  LDonorLoaded: Boolean;
  LNeedsListRefresh: Boolean;
begin
  if not MainDataset.Locate('Id', ADonationId, []) then
  begin
    ShowMessage('The selected record could not be found. Please refresh the list and try again.');
    Exit;
  end;
  if not TDonationUIUtils.DonationClaimStatusIsLocked(MainDataset.FieldByName('ClaimStatus').AsString) then
    MainDataset.Edit;

  LDonorId := MainDataset.FieldByName('DonorId').AsInteger;
  LDonorLoaded := await(Boolean, LoadDonorForId(LDonorId));

  AForm := TDonationDataEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());

    AForm.AllowEdit := not TDonationUIUtils.DonationClaimStatusIsLocked(
      MainDataset.FieldByName('ClaimStatus').AsString);

    if LDonorLoaded then
      AForm.SetDonorSnapshot(
        EditDonorDataset.FieldByName('DonorKind').AsString,
        EditDonorDataset.FieldByName('ClaimStatus').AsString,
        EditDonorDataset.FieldByName('Add1').AsString,
        EditDonorDataset.FieldByName('PostCode').AsString,
        EditDonorDataset.FieldByName('DateOfDeath').AsDateTime)
    else
      AForm.SetDonorSnapshot('', '', '', '', 0);

    AForm.DataSet := MainDataset;
    AForm.CheckEdit;
    AForm.AfterCreated;

    await(TModalResult, AForm.Execute);
  finally
    LNeedsListRefresh := Assigned(AForm) and AForm.EditDataApplyUpdates;
    if Assigned(AForm) then
    begin
      AForm.Free;
      AForm := nil;
    end;
    if MainDataset.Active and (MainDataset.State in dsEditModes) then
      MainDataset.Cancel;
    if EditDonorDataset.Active then
      EditDonorDataset.Close;
    if LNeedsListRefresh then
      Await(LoadDataAsync);
  end;
end;

procedure TUnclaimedValidationList.OpenDonorEdit(const ADonorId: Integer);
var
  AForm: TDonorEditForm;
  LApplyDonorUpdates: Boolean;
begin
  await(Boolean, LoadDonorForId(ADonorId));

  AForm := TDonorEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    await(TDonorEditForm, AForm.Load());
    AForm.IdField := 'Id';
    AForm.RecordViewOption := voEdit;
    AForm.Dataset := EditDonorDataset;
    await(TModalResult, AForm.Execute);
  finally
    if EditDonorDataset.Active and (EditDonorDataset.State in dsEditModes) then
      EditDonorDataset.Cancel;

    LApplyDonorUpdates := EditDonorDataset.Active and
      TXDataDSUtils.IsModified(TXDataWebDataSet(EditDonorDataset));

    if Assigned(AForm) then
    begin
      AForm.Free;
      AForm := nil;
    end;

    if LApplyDonorUpdates then
      Await(EditDonorDataset.ApplyUpdatesAsync);

    if EditDonorDataset.Active then
      EditDonorDataset.Close;

    Await(LoadDataAsync);
  end;
end;

procedure TUnclaimedValidationList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  CaptionSpan := THTMLSpan.Create('CaptionSpan');
  RefreshButton := TButton.Create('RefreshButton');
  AutoFixButton := TButton.Create('AutoFixButton');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDonorId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetSponsored := TBooleanField.Create(Self);
  MainDatasetNonGiftaidableByCustomerRequest := TBooleanField.Create(Self);
  MainDatasetTransactionDate := TDateTimeField.Create(Self);
  MainDatasetImportId := TIntegerField.Create(Self);
  MainDatasetClaimId := TIntegerField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetClaimDate := TDateTimeField.Create(Self);
  MainDatasetTaxYear := TIntegerField.Create(Self);
  MainDatasetDonorPostCode := TStringField.Create(Self);
  MainDatasetDonorName := TStringField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  MainDatasetComment := TStringField.Create(Self);
  MainDatasetDonationKind := TStringField.Create(Self);
  MainDatasetOtherDonationKind := TStringField.Create(Self);
  MainDatasetPaymentMethod := TStringField.Create(Self);
  MainDatasetPaymentMethodNote := TStringField.Create(Self);
  MainDatasetBankingDate := TDateField.Create(Self);
  MainDatasetBankingReference := TStringField.Create(Self);
  MainDatasetBankingReference2 := TStringField.Create(Self);
  MainDatasetAnalysisCode1 := TStringField.Create(Self);
  MainDatasetAnalysisCode2 := TStringField.Create(Self);
  MainDatasetAnalysisCode3 := TStringField.Create(Self);
  MainDatasetAdjustmentID := TIntegerField.Create(Self);
  MainDatasetValidationText := TStringField.Create(Self);
  EditDonorDataset := TXDataWebDataSet.Create(Self);
  EditDonorDatasetId := TIntegerField.Create(Self);
  EditDonorDatasetDateAdded := TDateTimeField.Create(Self);
  EditDonorDatasetAddedBy := TIntegerField.Create(Self);
  EditDonorDatasetLastUpdatedBy := TIntegerField.Create(Self);
  EditDonorDatasetLastUpdated := TDateTimeField.Create(Self);
  EditDonorDatasetTitle := TStringField.Create(Self);
  EditDonorDatasetFirstName := TStringField.Create(Self);
  EditDonorDatasetMiddleName := TStringField.Create(Self);
  EditDonorDatasetLastName := TStringField.Create(Self);
  EditDonorDatasetSuffix := TStringField.Create(Self);
  EditDonorDatasetAdd1 := TStringField.Create(Self);
  EditDonorDatasetAdd2 := TStringField.Create(Self);
  EditDonorDatasetAdd3 := TStringField.Create(Self);
  EditDonorDatasetCity := TStringField.Create(Self);
  EditDonorDatasetPostCode := TStringField.Create(Self);
  EditDonorDatasetEmail := TStringField.Create(Self);
  EditDonorDatasetMobile := TStringField.Create(Self);
  EditDonorDatasetTelephone := TStringField.Create(Self);
  EditDonorDatasetMatchHash := TStringField.Create(Self);
  EditDonorDatasetContactByPhone := TBooleanField.Create(Self);
  EditDonorDatasetContactByPost := TBooleanField.Create(Self);
  EditDonorDatasetContactByText := TBooleanField.Create(Self);
  EditDonorDatasetContactByEmail := TBooleanField.Create(Self);
  EditDonorDatasetDOB := TDateField.Create(Self);
  EditDonorDatasetHearingStatus := TStringField.Create(Self);
  EditDonorDatasetEmailStatus := TStringField.Create(Self);
  EditDonorDatasetLatitude := TFloatField.Create(Self);
  EditDonorDatasetLongitude := TFloatField.Create(Self);
  EditDonorDatasetExternalId := TStringField.Create(Self);
  EditDonorDatasetCountryCode := TStringField.Create(Self);
  EditDonorDatasetVisualStatus := TStringField.Create(Self);
  EditDonorDatasetMobilityStatus := TStringField.Create(Self);
  EditDonorDatasetSourceType := TStringField.Create(Self);
  EditDonorDatasetClaimStatus := TStringField.Create(Self);
  EditDonorDatasetCharityTenant := TStringField.Create(Self);
  EditDonorDatasetComments := TStringField.Create(Self);
  EditDonorDatasetImportId := TIntegerField.Create(Self);
  EditDonorDatasetCounty := TStringField.Create(Self);
  EditDonorDatasetLocationType := TStringField.Create(Self);
  EditDonorDatasetOrganisationName := TStringField.Create(Self);
  EditDonorDatasetDonorKind := TStringField.Create(Self);
  EditDonorDatasetDateOfDeath := TDateTimeField.Create(Self);

  DataTable.BeforeLoadDFMValues;
  CaptionSpan.BeforeLoadDFMValues;
  RefreshButton.BeforeLoadDFMValues;
  AutoFixButton.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDonorId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetSponsored.BeforeLoadDFMValues;
  MainDatasetNonGiftaidableByCustomerRequest.BeforeLoadDFMValues;
  MainDatasetTransactionDate.BeforeLoadDFMValues;
  MainDatasetImportId.BeforeLoadDFMValues;
  MainDatasetClaimId.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetClaimDate.BeforeLoadDFMValues;
  MainDatasetTaxYear.BeforeLoadDFMValues;
  MainDatasetDonorPostCode.BeforeLoadDFMValues;
  MainDatasetDonorName.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  MainDatasetComment.BeforeLoadDFMValues;
  MainDatasetDonationKind.BeforeLoadDFMValues;
  MainDatasetOtherDonationKind.BeforeLoadDFMValues;
  MainDatasetPaymentMethod.BeforeLoadDFMValues;
  MainDatasetPaymentMethodNote.BeforeLoadDFMValues;
  MainDatasetBankingDate.BeforeLoadDFMValues;
  MainDatasetBankingReference.BeforeLoadDFMValues;
  MainDatasetBankingReference2.BeforeLoadDFMValues;
  MainDatasetAnalysisCode1.BeforeLoadDFMValues;
  MainDatasetAnalysisCode2.BeforeLoadDFMValues;
  MainDatasetAnalysisCode3.BeforeLoadDFMValues;
  MainDatasetAdjustmentID.BeforeLoadDFMValues;
  MainDatasetValidationText.BeforeLoadDFMValues;
  EditDonorDataset.BeforeLoadDFMValues;
  EditDonorDatasetId.BeforeLoadDFMValues;
  EditDonorDatasetDateAdded.BeforeLoadDFMValues;
  EditDonorDatasetAddedBy.BeforeLoadDFMValues;
  EditDonorDatasetLastUpdatedBy.BeforeLoadDFMValues;
  EditDonorDatasetLastUpdated.BeforeLoadDFMValues;
  EditDonorDatasetTitle.BeforeLoadDFMValues;
  EditDonorDatasetFirstName.BeforeLoadDFMValues;
  EditDonorDatasetMiddleName.BeforeLoadDFMValues;
  EditDonorDatasetLastName.BeforeLoadDFMValues;
  EditDonorDatasetSuffix.BeforeLoadDFMValues;
  EditDonorDatasetAdd1.BeforeLoadDFMValues;
  EditDonorDatasetAdd2.BeforeLoadDFMValues;
  EditDonorDatasetAdd3.BeforeLoadDFMValues;
  EditDonorDatasetCity.BeforeLoadDFMValues;
  EditDonorDatasetPostCode.BeforeLoadDFMValues;
  EditDonorDatasetEmail.BeforeLoadDFMValues;
  EditDonorDatasetMobile.BeforeLoadDFMValues;
  EditDonorDatasetTelephone.BeforeLoadDFMValues;
  EditDonorDatasetMatchHash.BeforeLoadDFMValues;
  EditDonorDatasetContactByPhone.BeforeLoadDFMValues;
  EditDonorDatasetContactByPost.BeforeLoadDFMValues;
  EditDonorDatasetContactByText.BeforeLoadDFMValues;
  EditDonorDatasetContactByEmail.BeforeLoadDFMValues;
  EditDonorDatasetDOB.BeforeLoadDFMValues;
  EditDonorDatasetHearingStatus.BeforeLoadDFMValues;
  EditDonorDatasetEmailStatus.BeforeLoadDFMValues;
  EditDonorDatasetLatitude.BeforeLoadDFMValues;
  EditDonorDatasetLongitude.BeforeLoadDFMValues;
  EditDonorDatasetExternalId.BeforeLoadDFMValues;
  EditDonorDatasetCountryCode.BeforeLoadDFMValues;
  EditDonorDatasetVisualStatus.BeforeLoadDFMValues;
  EditDonorDatasetMobilityStatus.BeforeLoadDFMValues;
  EditDonorDatasetSourceType.BeforeLoadDFMValues;
  EditDonorDatasetClaimStatus.BeforeLoadDFMValues;
  EditDonorDatasetCharityTenant.BeforeLoadDFMValues;
  EditDonorDatasetComments.BeforeLoadDFMValues;
  EditDonorDatasetImportId.BeforeLoadDFMValues;
  EditDonorDatasetCounty.BeforeLoadDFMValues;
  EditDonorDatasetLocationType.BeforeLoadDFMValues;
  EditDonorDatasetOrganisationName.BeforeLoadDFMValues;
  EditDonorDatasetDonorKind.BeforeLoadDFMValues;
  EditDonorDatasetDateOfDeath.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Top := 110;
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'TransactionDate';
      Title := 'Transaction Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorName';
      Title := 'Donor';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonorPostCode';
      Title := 'Post Code';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ValidationText';
      Title := 'Error';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    CaptionSpan.SetParentComponent(Self);
    CaptionSpan.Name := 'CaptionSpan';
    CaptionSpan.Left := 632;
    CaptionSpan.Top := 48;
    CaptionSpan.Width := 100;
    CaptionSpan.Height := 40;
    CaptionSpan.HeightStyle := ssAuto;
    CaptionSpan.WidthStyle := ssAuto;
    CaptionSpan.ChildOrder := 10;
    CaptionSpan.ElementPosition := epIgnore;
    CaptionSpan.ElementFont := efCSS;
    CaptionSpan.Role := '';
    RefreshButton.SetParentComponent(Self);
    RefreshButton.Name := 'RefreshButton';
    RefreshButton.Left := 200;
    RefreshButton.Top := 408;
    RefreshButton.Width := 88;
    RefreshButton.Height := 25;
    RefreshButton.Caption := 'Refresh';
    RefreshButton.ChildOrder := 11;
    RefreshButton.ElementClassName := 'btn btn-outline-secondary';
    RefreshButton.ElementFont := efCSS;
    RefreshButton.ElementPosition := epIgnore;
    RefreshButton.HeightStyle := ssAuto;
    RefreshButton.HeightPercent := 100.000000000000000000;
    RefreshButton.WidthStyle := ssAuto;
    RefreshButton.WidthPercent := 100.000000000000000000;
    SetEvent(RefreshButton, Self, 'OnClick', 'RefreshButtonClick');
    AutoFixButton.SetParentComponent(Self);
    AutoFixButton.Name := 'AutoFixButton';
    AutoFixButton.Left := 296;
    AutoFixButton.Top := 408;
    AutoFixButton.Width := 96;
    AutoFixButton.Height := 25;
    AutoFixButton.Caption := 'Auto Fix';
    AutoFixButton.ChildOrder := 12;
    AutoFixButton.ElementClassName := 'btn btn-secondary';
    AutoFixButton.ElementFont := efCSS;
    AutoFixButton.ElementPosition := epIgnore;
    AutoFixButton.HeightStyle := ssAuto;
    AutoFixButton.HeightPercent := 100.000000000000000000;
    AutoFixButton.WidthStyle := ssAuto;
    AutoFixButton.WidthPercent := 100.000000000000000000;
    SetEvent(AutoFixButton, Self, 'OnClick', 'AutoFixButtonClick');
    MainDataset.EntitySetName := 'Donation';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDonorId.SetParentComponent(MainDataset);
    MainDatasetDonorId.Name := 'MainDatasetDonorId';
    MainDatasetDonorId.FieldName := 'DonorId';
    MainDatasetDonorId.Visible := False;
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 64;
    MainDatasetSponsored.SetParentComponent(MainDataset);
    MainDatasetSponsored.Name := 'MainDatasetSponsored';
    MainDatasetSponsored.FieldName := 'Sponsored';
    MainDatasetNonGiftaidableByCustomerRequest.SetParentComponent(MainDataset);
    MainDatasetNonGiftaidableByCustomerRequest.Name := 'MainDatasetNonGiftaidableByCustomerRequest';
    MainDatasetNonGiftaidableByCustomerRequest.FieldName := 'NonGiftaidableByCustomerRequest';
    MainDatasetTransactionDate.SetParentComponent(MainDataset);
    MainDatasetTransactionDate.Name := 'MainDatasetTransactionDate';
    MainDatasetTransactionDate.FieldName := 'TransactionDate';
    MainDatasetTransactionDate.DisplayFormat := 'DD/MM/YYYY';
    MainDatasetImportId.SetParentComponent(MainDataset);
    MainDatasetImportId.Name := 'MainDatasetImportId';
    MainDatasetImportId.FieldName := 'ImportId';
    MainDatasetClaimId.SetParentComponent(MainDataset);
    MainDatasetClaimId.Name := 'MainDatasetClaimId';
    MainDatasetClaimId.FieldName := 'ClaimId';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.FieldName := 'Amount';
    MainDatasetAmount.DisplayFormat := '#,##0.00';
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 9;
    MainDatasetClaimDate.SetParentComponent(MainDataset);
    MainDatasetClaimDate.Name := 'MainDatasetClaimDate';
    MainDatasetClaimDate.FieldName := 'ClaimDate';
    MainDatasetTaxYear.SetParentComponent(MainDataset);
    MainDatasetTaxYear.Name := 'MainDatasetTaxYear';
    MainDatasetTaxYear.FieldName := 'TaxYear';
    MainDatasetDonorPostCode.SetParentComponent(MainDataset);
    MainDatasetDonorPostCode.Name := 'MainDatasetDonorPostCode';
    MainDatasetDonorPostCode.FieldName := 'DonorPostCode';
    MainDatasetDonorPostCode.Size := 15;
    MainDatasetDonorName.SetParentComponent(MainDataset);
    MainDatasetDonorName.Name := 'MainDatasetDonorName';
    MainDatasetDonorName.FieldName := 'DonorName';
    MainDatasetDonorName.Size := 100;
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    MainDatasetComment.SetParentComponent(MainDataset);
    MainDatasetComment.Name := 'MainDatasetComment';
    MainDatasetComment.FieldName := 'Comment';
    MainDatasetComment.Size := 2048;
    MainDatasetDonationKind.SetParentComponent(MainDataset);
    MainDatasetDonationKind.Name := 'MainDatasetDonationKind';
    MainDatasetDonationKind.FieldName := 'DonationKind';
    MainDatasetDonationKind.Size := 18;
    MainDatasetOtherDonationKind.SetParentComponent(MainDataset);
    MainDatasetOtherDonationKind.Name := 'MainDatasetOtherDonationKind';
    MainDatasetOtherDonationKind.FieldName := 'OtherDonationKind';
    MainDatasetOtherDonationKind.Size := 100;
    MainDatasetPaymentMethod.SetParentComponent(MainDataset);
    MainDatasetPaymentMethod.Name := 'MainDatasetPaymentMethod';
    MainDatasetPaymentMethod.FieldName := 'PaymentMethod';
    MainDatasetPaymentMethod.Size := 14;
    MainDatasetPaymentMethodNote.SetParentComponent(MainDataset);
    MainDatasetPaymentMethodNote.Name := 'MainDatasetPaymentMethodNote';
    MainDatasetPaymentMethodNote.FieldName := 'PaymentMethodNote';
    MainDatasetPaymentMethodNote.Size := 75;
    MainDatasetBankingDate.SetParentComponent(MainDataset);
    MainDatasetBankingDate.Name := 'MainDatasetBankingDate';
    MainDatasetBankingDate.FieldName := 'BankingDate';
    MainDatasetBankingReference.SetParentComponent(MainDataset);
    MainDatasetBankingReference.Name := 'MainDatasetBankingReference';
    MainDatasetBankingReference.FieldName := 'BankingReference';
    MainDatasetBankingReference.Size := 25;
    MainDatasetBankingReference2.SetParentComponent(MainDataset);
    MainDatasetBankingReference2.Name := 'MainDatasetBankingReference2';
    MainDatasetBankingReference2.FieldName := 'BankingReference2';
    MainDatasetBankingReference2.Size := 25;
    MainDatasetAnalysisCode1.SetParentComponent(MainDataset);
    MainDatasetAnalysisCode1.Name := 'MainDatasetAnalysisCode1';
    MainDatasetAnalysisCode1.FieldName := 'AnalysisCode1';
    MainDatasetAnalysisCode1.Size := 64;
    MainDatasetAnalysisCode2.SetParentComponent(MainDataset);
    MainDatasetAnalysisCode2.Name := 'MainDatasetAnalysisCode2';
    MainDatasetAnalysisCode2.FieldName := 'AnalysisCode2';
    MainDatasetAnalysisCode2.Size := 64;
    MainDatasetAnalysisCode3.SetParentComponent(MainDataset);
    MainDatasetAnalysisCode3.Name := 'MainDatasetAnalysisCode3';
    MainDatasetAnalysisCode3.FieldName := 'AnalysisCode3';
    MainDatasetAnalysisCode3.Size := 64;
    MainDatasetAdjustmentID.SetParentComponent(MainDataset);
    MainDatasetAdjustmentID.Name := 'MainDatasetAdjustmentID';
    MainDatasetAdjustmentID.FieldName := 'AdjustmentID';
    MainDatasetValidationText.SetParentComponent(MainDataset);
    MainDatasetValidationText.Name := 'MainDatasetValidationText';
    MainDatasetValidationText.FieldKind := fkCalculated;
    MainDatasetValidationText.FieldName := 'ValidationText';
    SetEvent(MainDatasetValidationText, Self, 'OnGetText', 'MainDatasetValidationTextGetText');
    MainDatasetValidationText.Calculated := True;
    EditDonorDataset.SetParentComponent(Self);
    EditDonorDataset.Name := 'EditDonorDataset';
    EditDonorDataset.EntitySetName := 'Donor';
    EditDonorDataset.Connection := MainData.DataConnection;
    EditDonorDatasetId.SetParentComponent(EditDonorDataset);
    EditDonorDatasetId.Name := 'EditDonorDatasetId';
    EditDonorDatasetId.FieldName := 'Id';
    EditDonorDatasetDateAdded.SetParentComponent(EditDonorDataset);
    EditDonorDatasetDateAdded.Name := 'EditDonorDatasetDateAdded';
    EditDonorDatasetDateAdded.FieldName := 'DateAdded';
    EditDonorDatasetAddedBy.SetParentComponent(EditDonorDataset);
    EditDonorDatasetAddedBy.Name := 'EditDonorDatasetAddedBy';
    EditDonorDatasetAddedBy.FieldName := 'AddedBy';
    EditDonorDatasetLastUpdatedBy.SetParentComponent(EditDonorDataset);
    EditDonorDatasetLastUpdatedBy.Name := 'EditDonorDatasetLastUpdatedBy';
    EditDonorDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    EditDonorDatasetLastUpdated.SetParentComponent(EditDonorDataset);
    EditDonorDatasetLastUpdated.Name := 'EditDonorDatasetLastUpdated';
    EditDonorDatasetLastUpdated.FieldName := 'LastUpdated';
    EditDonorDatasetTitle.SetParentComponent(EditDonorDataset);
    EditDonorDatasetTitle.Name := 'EditDonorDatasetTitle';
    EditDonorDatasetTitle.FieldName := 'Title';
    EditDonorDatasetTitle.Size := 25;
    EditDonorDatasetFirstName.SetParentComponent(EditDonorDataset);
    EditDonorDatasetFirstName.Name := 'EditDonorDatasetFirstName';
    EditDonorDatasetFirstName.FieldName := 'FirstName';
    EditDonorDatasetFirstName.Size := 50;
    EditDonorDatasetMiddleName.SetParentComponent(EditDonorDataset);
    EditDonorDatasetMiddleName.Name := 'EditDonorDatasetMiddleName';
    EditDonorDatasetMiddleName.FieldName := 'MiddleName';
    EditDonorDatasetMiddleName.Size := 50;
    EditDonorDatasetLastName.SetParentComponent(EditDonorDataset);
    EditDonorDatasetLastName.Name := 'EditDonorDatasetLastName';
    EditDonorDatasetLastName.FieldName := 'LastName';
    EditDonorDatasetLastName.Size := 50;
    EditDonorDatasetSuffix.SetParentComponent(EditDonorDataset);
    EditDonorDatasetSuffix.Name := 'EditDonorDatasetSuffix';
    EditDonorDatasetSuffix.FieldName := 'Suffix';
    EditDonorDatasetSuffix.Size := 50;
    EditDonorDatasetAdd1.SetParentComponent(EditDonorDataset);
    EditDonorDatasetAdd1.Name := 'EditDonorDatasetAdd1';
    EditDonorDatasetAdd1.FieldName := 'Add1';
    EditDonorDatasetAdd1.Size := 75;
    EditDonorDatasetAdd2.SetParentComponent(EditDonorDataset);
    EditDonorDatasetAdd2.Name := 'EditDonorDatasetAdd2';
    EditDonorDatasetAdd2.FieldName := 'Add2';
    EditDonorDatasetAdd2.Size := 75;
    EditDonorDatasetAdd3.SetParentComponent(EditDonorDataset);
    EditDonorDatasetAdd3.Name := 'EditDonorDatasetAdd3';
    EditDonorDatasetAdd3.FieldName := 'Add3';
    EditDonorDatasetAdd3.Size := 75;
    EditDonorDatasetCity.SetParentComponent(EditDonorDataset);
    EditDonorDatasetCity.Name := 'EditDonorDatasetCity';
    EditDonorDatasetCity.FieldName := 'City';
    EditDonorDatasetCity.Size := 75;
    EditDonorDatasetPostCode.SetParentComponent(EditDonorDataset);
    EditDonorDatasetPostCode.Name := 'EditDonorDatasetPostCode';
    EditDonorDatasetPostCode.FieldName := 'PostCode';
    EditDonorDatasetPostCode.Size := 15;
    EditDonorDatasetEmail.SetParentComponent(EditDonorDataset);
    EditDonorDatasetEmail.Name := 'EditDonorDatasetEmail';
    EditDonorDatasetEmail.FieldName := 'Email';
    EditDonorDatasetEmail.Size := 75;
    EditDonorDatasetMobile.SetParentComponent(EditDonorDataset);
    EditDonorDatasetMobile.Name := 'EditDonorDatasetMobile';
    EditDonorDatasetMobile.FieldName := 'Mobile';
    EditDonorDatasetMobile.Size := 25;
    EditDonorDatasetTelephone.SetParentComponent(EditDonorDataset);
    EditDonorDatasetTelephone.Name := 'EditDonorDatasetTelephone';
    EditDonorDatasetTelephone.FieldName := 'Telephone';
    EditDonorDatasetTelephone.Size := 25;
    EditDonorDatasetMatchHash.SetParentComponent(EditDonorDataset);
    EditDonorDatasetMatchHash.Name := 'EditDonorDatasetMatchHash';
    EditDonorDatasetMatchHash.FieldName := 'MatchHash';
    EditDonorDatasetMatchHash.Size := 64;
    EditDonorDatasetContactByPhone.SetParentComponent(EditDonorDataset);
    EditDonorDatasetContactByPhone.Name := 'EditDonorDatasetContactByPhone';
    EditDonorDatasetContactByPhone.FieldName := 'ContactByPhone';
    EditDonorDatasetContactByPost.SetParentComponent(EditDonorDataset);
    EditDonorDatasetContactByPost.Name := 'EditDonorDatasetContactByPost';
    EditDonorDatasetContactByPost.FieldName := 'ContactByPost';
    EditDonorDatasetContactByText.SetParentComponent(EditDonorDataset);
    EditDonorDatasetContactByText.Name := 'EditDonorDatasetContactByText';
    EditDonorDatasetContactByText.FieldName := 'ContactByText';
    EditDonorDatasetContactByEmail.SetParentComponent(EditDonorDataset);
    EditDonorDatasetContactByEmail.Name := 'EditDonorDatasetContactByEmail';
    EditDonorDatasetContactByEmail.FieldName := 'ContactByEmail';
    EditDonorDatasetDOB.SetParentComponent(EditDonorDataset);
    EditDonorDatasetDOB.Name := 'EditDonorDatasetDOB';
    EditDonorDatasetDOB.FieldName := 'DOB';
    EditDonorDatasetHearingStatus.SetParentComponent(EditDonorDataset);
    EditDonorDatasetHearingStatus.Name := 'EditDonorDatasetHearingStatus';
    EditDonorDatasetHearingStatus.FieldName := 'HearingStatus';
    EditDonorDatasetHearingStatus.Size := 8;
    EditDonorDatasetEmailStatus.SetParentComponent(EditDonorDataset);
    EditDonorDatasetEmailStatus.Name := 'EditDonorDatasetEmailStatus';
    EditDonorDatasetEmailStatus.FieldName := 'EmailStatus';
    EditDonorDatasetEmailStatus.Size := 10;
    EditDonorDatasetLatitude.SetParentComponent(EditDonorDataset);
    EditDonorDatasetLatitude.Name := 'EditDonorDatasetLatitude';
    EditDonorDatasetLatitude.FieldName := 'Latitude';
    EditDonorDatasetLongitude.SetParentComponent(EditDonorDataset);
    EditDonorDatasetLongitude.Name := 'EditDonorDatasetLongitude';
    EditDonorDatasetLongitude.FieldName := 'Longitude';
    EditDonorDatasetExternalId.SetParentComponent(EditDonorDataset);
    EditDonorDatasetExternalId.Name := 'EditDonorDatasetExternalId';
    EditDonorDatasetExternalId.FieldName := 'ExternalId';
    EditDonorDatasetExternalId.Size := 64;
    EditDonorDatasetCountryCode.SetParentComponent(EditDonorDataset);
    EditDonorDatasetCountryCode.Name := 'EditDonorDatasetCountryCode';
    EditDonorDatasetCountryCode.FieldName := 'CountryCode';
    EditDonorDatasetCountryCode.Size := 3;
    EditDonorDatasetVisualStatus.SetParentComponent(EditDonorDataset);
    EditDonorDatasetVisualStatus.Name := 'EditDonorDatasetVisualStatus';
    EditDonorDatasetVisualStatus.FieldName := 'VisualStatus';
    EditDonorDatasetVisualStatus.Size := 8;
    EditDonorDatasetMobilityStatus.SetParentComponent(EditDonorDataset);
    EditDonorDatasetMobilityStatus.Name := 'EditDonorDatasetMobilityStatus';
    EditDonorDatasetMobilityStatus.FieldName := 'MobilityStatus';
    EditDonorDatasetMobilityStatus.Size := 8;
    EditDonorDatasetSourceType.SetParentComponent(EditDonorDataset);
    EditDonorDatasetSourceType.Name := 'EditDonorDatasetSourceType';
    EditDonorDatasetSourceType.FieldName := 'SourceType';
    EditDonorDatasetSourceType.Size := 9;
    EditDonorDatasetClaimStatus.SetParentComponent(EditDonorDataset);
    EditDonorDatasetClaimStatus.Name := 'EditDonorDatasetClaimStatus';
    EditDonorDatasetClaimStatus.FieldName := 'ClaimStatus';
    EditDonorDatasetClaimStatus.Size := 19;
    EditDonorDatasetCharityTenant.SetParentComponent(EditDonorDataset);
    EditDonorDatasetCharityTenant.Name := 'EditDonorDatasetCharityTenant';
    EditDonorDatasetCharityTenant.FieldName := 'CharityTenant';
    EditDonorDatasetComments.SetParentComponent(EditDonorDataset);
    EditDonorDatasetComments.Name := 'EditDonorDatasetComments';
    EditDonorDatasetComments.FieldName := 'Comments';
    EditDonorDatasetComments.Size := 2048;
    EditDonorDatasetImportId.SetParentComponent(EditDonorDataset);
    EditDonorDatasetImportId.Name := 'EditDonorDatasetImportId';
    EditDonorDatasetImportId.FieldName := 'ImportId';
    EditDonorDatasetCounty.SetParentComponent(EditDonorDataset);
    EditDonorDatasetCounty.Name := 'EditDonorDatasetCounty';
    EditDonorDatasetCounty.FieldName := 'County';
    EditDonorDatasetCounty.Size := 75;
    EditDonorDatasetLocationType.SetParentComponent(EditDonorDataset);
    EditDonorDatasetLocationType.Name := 'EditDonorDatasetLocationType';
    EditDonorDatasetLocationType.FieldName := 'LocationType';
    EditDonorDatasetLocationType.Size := 8;
    EditDonorDatasetOrganisationName.SetParentComponent(EditDonorDataset);
    EditDonorDatasetOrganisationName.Name := 'EditDonorDatasetOrganisationName';
    EditDonorDatasetOrganisationName.FieldName := 'OrganisationName';
    EditDonorDatasetOrganisationName.Size := 250;
    EditDonorDatasetDonorKind.SetParentComponent(EditDonorDataset);
    EditDonorDatasetDonorKind.Name := 'EditDonorDatasetDonorKind';
    EditDonorDatasetDonorKind.FieldName := 'DonorKind';
    EditDonorDatasetDonorKind.Size := 10;
    EditDonorDatasetDateOfDeath.SetParentComponent(EditDonorDataset);
    EditDonorDatasetDateOfDeath.Name := 'EditDonorDatasetDateOfDeath';
    EditDonorDatasetDateOfDeath.FieldName := 'DateOfDeath';
    EditDonorDatasetDateOfDeath.DisplayFormat := 'DD/MM/YYYY';
  finally
    DataTable.AfterLoadDFMValues;
    CaptionSpan.AfterLoadDFMValues;
    RefreshButton.AfterLoadDFMValues;
    AutoFixButton.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDonorId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetSponsored.AfterLoadDFMValues;
    MainDatasetNonGiftaidableByCustomerRequest.AfterLoadDFMValues;
    MainDatasetTransactionDate.AfterLoadDFMValues;
    MainDatasetImportId.AfterLoadDFMValues;
    MainDatasetClaimId.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetClaimDate.AfterLoadDFMValues;
    MainDatasetTaxYear.AfterLoadDFMValues;
    MainDatasetDonorPostCode.AfterLoadDFMValues;
    MainDatasetDonorName.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    MainDatasetComment.AfterLoadDFMValues;
    MainDatasetDonationKind.AfterLoadDFMValues;
    MainDatasetOtherDonationKind.AfterLoadDFMValues;
    MainDatasetPaymentMethod.AfterLoadDFMValues;
    MainDatasetPaymentMethodNote.AfterLoadDFMValues;
    MainDatasetBankingDate.AfterLoadDFMValues;
    MainDatasetBankingReference.AfterLoadDFMValues;
    MainDatasetBankingReference2.AfterLoadDFMValues;
    MainDatasetAnalysisCode1.AfterLoadDFMValues;
    MainDatasetAnalysisCode2.AfterLoadDFMValues;
    MainDatasetAnalysisCode3.AfterLoadDFMValues;
    MainDatasetAdjustmentID.AfterLoadDFMValues;
    MainDatasetValidationText.AfterLoadDFMValues;
    EditDonorDataset.AfterLoadDFMValues;
    EditDonorDatasetId.AfterLoadDFMValues;
    EditDonorDatasetDateAdded.AfterLoadDFMValues;
    EditDonorDatasetAddedBy.AfterLoadDFMValues;
    EditDonorDatasetLastUpdatedBy.AfterLoadDFMValues;
    EditDonorDatasetLastUpdated.AfterLoadDFMValues;
    EditDonorDatasetTitle.AfterLoadDFMValues;
    EditDonorDatasetFirstName.AfterLoadDFMValues;
    EditDonorDatasetMiddleName.AfterLoadDFMValues;
    EditDonorDatasetLastName.AfterLoadDFMValues;
    EditDonorDatasetSuffix.AfterLoadDFMValues;
    EditDonorDatasetAdd1.AfterLoadDFMValues;
    EditDonorDatasetAdd2.AfterLoadDFMValues;
    EditDonorDatasetAdd3.AfterLoadDFMValues;
    EditDonorDatasetCity.AfterLoadDFMValues;
    EditDonorDatasetPostCode.AfterLoadDFMValues;
    EditDonorDatasetEmail.AfterLoadDFMValues;
    EditDonorDatasetMobile.AfterLoadDFMValues;
    EditDonorDatasetTelephone.AfterLoadDFMValues;
    EditDonorDatasetMatchHash.AfterLoadDFMValues;
    EditDonorDatasetContactByPhone.AfterLoadDFMValues;
    EditDonorDatasetContactByPost.AfterLoadDFMValues;
    EditDonorDatasetContactByText.AfterLoadDFMValues;
    EditDonorDatasetContactByEmail.AfterLoadDFMValues;
    EditDonorDatasetDOB.AfterLoadDFMValues;
    EditDonorDatasetHearingStatus.AfterLoadDFMValues;
    EditDonorDatasetEmailStatus.AfterLoadDFMValues;
    EditDonorDatasetLatitude.AfterLoadDFMValues;
    EditDonorDatasetLongitude.AfterLoadDFMValues;
    EditDonorDatasetExternalId.AfterLoadDFMValues;
    EditDonorDatasetCountryCode.AfterLoadDFMValues;
    EditDonorDatasetVisualStatus.AfterLoadDFMValues;
    EditDonorDatasetMobilityStatus.AfterLoadDFMValues;
    EditDonorDatasetSourceType.AfterLoadDFMValues;
    EditDonorDatasetClaimStatus.AfterLoadDFMValues;
    EditDonorDatasetCharityTenant.AfterLoadDFMValues;
    EditDonorDatasetComments.AfterLoadDFMValues;
    EditDonorDatasetImportId.AfterLoadDFMValues;
    EditDonorDatasetCounty.AfterLoadDFMValues;
    EditDonorDatasetLocationType.AfterLoadDFMValues;
    EditDonorDatasetOrganisationName.AfterLoadDFMValues;
    EditDonorDatasetDonorKind.AfterLoadDFMValues;
    EditDonorDatasetDateOfDeath.AfterLoadDFMValues;
  end;
end;

end.

